import { LocaleString } from "@grupo-constant/next-dtype/i18n";
import { DType, JsonReply, SelectOption } from "@grupo-constant/next-dtype/types";

export const MASTER_URI = 'dtype://com.cloudcodice.feature.master.Master';

export interface MasterData extends DType {
    name?: string;
    index?: { column: string[]; unique: boolean }[];
    columnsForList?: string[];
    availableColumnsForList?: string[];
    columnsForExternalFilter?: string[];
    export?: string[];
    mask?: string;
    typology?: MasterTypology;
    validity?: MasterValidity;
    icon?: string;
    pseudoStatic?: boolean;
    noUpdate?: boolean;
    noInsert?: boolean;
    noDelete?: boolean;
    isManualOrder?: boolean;
}

export class CategoryNode {
    category?: CategoryNode[];
    name: LocaleString;
    oid: string;
}

export interface RetrieveMasterCategoryTreeReply {
    status: number;
    tree: CategoryNode[];
    uri: string;
}

export interface RetrieveMasterDataAsSelectOptionReply extends JsonReply {
    selectOptions: SelectOption[];
}

export interface NextValueBody {
    sequenceName: string;
    chunkSize: number;
    typeIfNotExists?: string;
}

export interface NextValueReply {
    status: number;
    sequenceName: string;
    chunkSize: number;
    value: string[];
}

export interface DownloadMasterXSSFBody {
    uri: string;
    language?: string;
}

export interface UploadMasterXSSFBody {
    uri: string;
    release: number;
    base64: string;
    forceUpload: boolean;
    async: boolean;
    keepOriginalData: boolean;
}

export interface UploadMasterXSSFResponse extends JsonReply {
    async?: boolean;
    created?: number;
    deleted?: number;
    updated?: number;
    processed?: number;
    errors?: number;
    warns?: number;
    base64?: string;
}

export interface FlushMasterCategoryTreeReply extends JsonReply {
    status: number;
}

export enum MasterTypology {
    GENERAL = 'GENERAL',
    PLANNINGZONES = 'PLANNINGZONES',
    WORKPLACES = 'WORKPLACES',
    WORKDAYTYPE = 'WORKDAYTYPE',
    CATALOG = 'CATALOG',
    LOCATION = 'LOCATION',
    PROFESSIONAL_CATEGORY = 'PROFESSIONAL_CATEGORY',
    SYSTEM_CONFIG = 'SYSTEM_CONFIG'
}

export enum MasterValidity {
    FLAG = 'FLAG',
    PERIOD = 'PERIOD',
    DELETE = 'DELETE'
}
